import React from 'react';
import Icon from '../../../components/AppIcon';
import AppImage from '../../../components/AppImage';

const WonItemsGrid = ({ items, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {[1, 2, 3]?.map(i => (
          <div key={i} className="bg-card border border-border rounded-xl p-4 animate-pulse">
            <div className="w-full h-40 bg-muted rounded-lg mb-3" />
            <div className="h-4 bg-muted rounded w-3/4 mb-2" />
            <div className="h-3 bg-muted rounded w-1/2" />
          </div>
        ))}
      </div>
    );
  }

  if (!items?.length) {
    return (
      <div className="bg-card border border-border rounded-xl p-12 text-center">
        <Icon name="Trophy" size={40} className="mx-auto text-muted-foreground mb-3" />
        <h3 className="text-base font-semibold text-foreground mb-1">No won items yet</h3>
        <p className="text-muted-foreground text-sm">Win your first auction to see items here</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {items?.map((bid, i) => {
        const auction = bid?.auction;
        const wonDate = bid?.created_at ? new Date(bid?.created_at)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—';

        return (
          <div key={bid?.id || i} className="bg-card border border-border rounded-xl overflow-hidden hover:shadow-md transition-all duration-200 group">
            {/* Image */}
            <div className="relative w-full h-44 bg-muted overflow-hidden">
              {auction?.featured_image_url ? (
                <AppImage
                  src={auction?.featured_image_url}
                  alt={auction?.title || 'Won auction item'}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <Icon name="Package" size={32} className="text-muted-foreground" />
                </div>
              )}
              {/* Won badge */}
              <div className="absolute top-3 left-3">
                <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold bg-yellow-500/90 text-yellow-950 backdrop-blur-sm">
                  <Icon name="Trophy" size={11} />
                  Won
                </span>
              </div>
            </div>

            {/* Content */}
            <div className="p-4">
              <h4 className="text-sm font-semibold text-foreground truncate mb-1">{auction?.title || 'Untitled Auction'}</h4>
              <p className="text-xs text-muted-foreground mb-3">Won on {wonDate}</p>

              <div className="flex items-center justify-between">
                <div>
                  <p className="text-xs text-muted-foreground">Winning Bid</p>
                  <p className="text-base font-bold text-primary">
                    ${parseFloat(bid?.bid_amount || 0)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-xs text-muted-foreground">Seller</p>
                  <p className="text-xs font-medium text-foreground truncate max-w-24">{auction?.seller?.full_name || '—'}</p>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default WonItemsGrid;
